import { render } from "./SearchForm.vue?vue&type=template&id=6364b514&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=6364b514&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6364b514"

export default script